
import React from 'react';
import AppLayout from '@/components/layout/AppLayout';
import ApplicationLogin from '@/components/application/ApplicationLogin';

const LoginPage = () => {
  return (
    <AppLayout showJobPosting={false}>
      <div className="container mx-auto px-4 md:px-8 flex items-center justify-center min-h-[60vh]">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold mb-2 text-jungle">Access Your Application</h1>
            <p className="text-gray-600">
              Enter your details to continue your application process
            </p>
          </div>
          <ApplicationLogin />
        </div>
      </div>
    </AppLayout>
  );
};

export default LoginPage;
